var React = require('react');

function PenNib (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M288 96l128 128-42.79 151.4a64 64 0 0 1-41.35 43.31L52 512l-14.69-14.69L187.42 347.2a48.45 48.45 0 1 0-22.62-22.62L14.69 474.69 0 460l93.29-279.86a64 64 0 0 1 43.31-41.35z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M497.94 74.17a48 48 0 0 1 0 67.91l-56.55 56.55-128-128 56.55-56.55a48 48 0 0 1 67.91 0z","className":"fa-primary","key":2})]);
}

PenNib.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = PenNib;

PenNib.default = PenNib;
